import React from "react";
import Select from "../../../../common/components/elements/select/Select";

function PredefinedQuantitySelector({product, onChange, value, width, ...props}) {
  const options = product.getWeightPrices().map(opt => ({label: opt.label, value: opt}));
  return (
    <Select
      width={width}
      options={options}
      onChange={onChange}
      value={value}
      {...props}
    />
  );
}

export default PredefinedQuantitySelector;
